import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-virtual-card',
  templateUrl: './edit-virtual-card.component.html',
  styleUrls: ['./edit-virtual-card.component.scss']
})
export class EditVirtualCardComponent implements OnInit, AfterViewInit {
  @Input() cardInfo: any;
  fileImg64: any;
  wrongSize: any;
  cardForm: FormGroup;
  maxLength = 150;
  cardType: any;
  isThisButton = false;
  // cardsInColumnOne: any;
  // cardsInColumnTwo: any;
  cardsOrder: any;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.fileImg64 = this.cardInfo ? this.cardInfo.img : null;
    // this.cardsInColumnOne = this.cardInfo.all.filter(x => x.column === 1);
    // this.cardsInColumnTwo = this.cardInfo.all.filter(x => x.column === 2);
    this.createForm();
  }


  ngAfterViewInit(): void {
    this.cardType = this.cardInfo && this.cardInfo.typeId ? this.cardInfo.typeId : 1;
    if (this.cardInfo.id) {
      this.updateForm();
    }
    if (this.cardInfo.column === 1) {
      this.cardsOrder = this.cardInfo.id
        ? new Array(this.cardInfo.all.filter(x => x.column === 1 && x.status === 'Activo').length)
        : new Array(this.cardInfo.all.filter(x => x.column === 1 && x.status === 'Activo').length + 1);
    } else {
      this.cardsOrder = this.cardInfo.id
        ? new Array(this.cardInfo.all.filter(x => x.column === 2 && x.status === 'Activo').length)
        : new Array(this.cardInfo.all.filter(x => x.column === 2 && x.status === 'Activo').length + 1);
    }
  }

  changeColumn(column): any {
    this.cardForm.get('order').setValue(1);
    if (this.cardInfo.id) {
      if (column !== this.cardInfo.column) {
        this.cardsOrder = new Array(this.cardInfo.all.filter(x => x.column === column && x.status === 'Activo').length + 1);
      } else {
        this.cardsOrder = new Array(this.cardInfo.all.filter(x => x.column === column && x.status === 'Activo').length);
      }
    } else {
      this.cardsOrder = new Array(this.cardInfo.all.filter(x => x.column === column && x.status === 'Activo').length + 1);
    }
  }

  sendData(): any {
    this.cardForm.get('codeImg').setValue(Number(this.cardForm.value.codeImg));
    const dataToSend = {
      ...this.cardForm.value,
      img64Upload: this.cardInfo.img64Upload,
    };
    if (dataToSend.column === 2) {
      dataToSend.order = dataToSend.order + this.cardInfo.all.filter(x => x.column === 1).length;
    }

    if (this.cardInfo.id) {
      dataToSend.id = this.cardInfo.id;
    }

    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.cardForm = this.fb.group({
      title: ['', Validators.required],
      order: [1 , Validators.required],
      column: [1, Validators.required],
      typeId: [null, Validators.required],
      nameButton: [''],
      activeButton: [0],
      url: [''],
      img: [''],
      img64: ['', Validators.required],
      subTitle: [''],
      codeImg: [3],
    });
  }

  get typeId(): any {
    return this.cardForm.get('typeId');
  }


  private updateForm(): any {
    this.cardForm.get('title').setValue(this.cardInfo.title);
    this.cardForm.get('subTitle').setValue(this.cardInfo.subTitle);

    this.cardForm.get('column').setValue(this.cardInfo.column);
    this.cardForm.get('url').setValue(this.cardInfo.url);
    this.cardForm.get('activeButton').setValue(this.cardInfo.activeButton);
    this.cardForm.get('typeId').setValue(this.cardInfo.typeId);
    // this.cardForm.get('codeImg').setValue(this.cardInfo.codeImg);
    this.cardForm.get('img64').setValue(this.cardInfo.img);
    // this.cardForm.get('img').setValue(this.cardInfo.img);
    this.cardInfo.img64Upload = false;
    //
    // this.isThisButton = this.cardInfo.activeButton === 1 && (this.cardInfo.url !== null && this.cardInfo.url !== '');
    if (this.cardInfo.column === 2) {
      this.cardForm.get('order').setValue(this.cardInfo.orderId - this.cardInfo.all.filter(x => x.column === 1).length)
    } else {
      this.cardForm.get('order').setValue(this.cardInfo.orderId);
    }
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 200 && image.height <= 150) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.cardForm.get('img').setValue((event.target.files[0]).name);
          this.cardForm.get('img64').setValue(this.fileImg64.split(',')[1]);
          this.cardInfo.img64Upload = true;
        } else {
          this.wrongSize = 'Resolución de imagen no permitida (requerida: 200px x 150px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }


  setButtonNull() {
    this.isThisButton = false;
    this.cardForm.get('activeButton').setValue(0);
    this.cardForm.get('nameButton').setValue('');
  }

  setUrl() {
    this.cardType = 2;
  }

  setFormCard() {
    this.cardType = 1;
    this.cardForm.get('subTitle').setValue(null);
    this.cardForm.get('url').setValue(null);
    this.setButtonNull();
  }
}
